/**
 * @desc 导出付款To单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.paymentMaster.exportPayRequestToReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/exportPayRequestToReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
